<template>
    <div v-if="value && value.length">
        <div class="question-select-text__title">Выделенный текст:</div>
        <v-chip v-for="(item, i) in value" :key="i" close @input="onRemove(i)">{{item.text | length}}</v-chip>
    </div>
</template>
<script>
    export default {
        props: {
            value: [Array],
            id: [String, Number]
        },
        methods: {
            onRemove (index) {
                let value = this.value.filter((item, i) => i !== index)
                this.$emit('input', value)
            }
        },
        watch: {
            id () {}
        },
        filters: {
            length (value) {
                let res = value.slice(0, 45)
                if (res.length < value.length) res += '...'
                return res
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .question-select-text {
        &__title {
            font-weight bold
        }
    }
</style>